import Icon from "@ant-design/icons";
import {ReactComponent as CropSvg} from "./svgs/crops.svg";

const CropIcon = (props) => <Icon component={CropSvg} {...props} />;

export {CropIcon}
